<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="fuelbalance_first_row_right_section tank__bg"
          style="flex: 0 0 96.5%; border-radius: 15px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="our__branches__banner" style="width: 100%; height: 150px">
            <div class="row align-items-center section__row">
              <div class="col-md-7 text-center section___column_1">
                <h3 class="our__branches__banner__title">
                  <img src="@/assets/img/tanks_icon.png" class="mr-3" />
                  {{ $t("text.tanksFilledReport.title") }} ({{
                    TanksFilledCount
                  }})
                </h3>
              </div>
              <div class="col-md-3 drop_down_input_group">
                <div class="align-items-center">
                  <div class>
                    <div class="drop_down_section mt-2 mr-2">
                      <div class="drop_down_div align-items-center">
                        <vue-ctk-date-time-picker
                          v-model="dateRange"
                          :max-date="maxDate"
                          :disabledDates="disabledDates"
                          :onlyDate="true"
                          :autoClose="true"
                          :locale="this.$root.$i18n.locale"
                          :color="$store.getters.getDatePickerColor"
                          format="DDMMYYYY"
                          formatted="DD/MM/YYYY"
                          :label="$t('text.calendar.selectDate')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section
        v-show="TanksFilledCount > 0 && !showLoader"
        class="mobile_tanks_filled"
      >
        <div class="dashboard__table__section mt-3">
          <div class="branch__sales__text_header">
            <div class="row">
              <div class="col-md-8">
                <span>
                  {{ $t("text.tanksFilledReport.tanksFilledOn") }}
                  {{
                    $d(new Date(startDate), "short", this.$root.$i18n.locale)
                  }}
                </span>
              </div>
              <div class="col-md-4 text-right"></div>
            </div>
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
            >
              <e-columns>
                <e-column width="40" field="index" headerText="#"></e-column>
                <e-column
                  field="branchName"
                  width="200"
                  :headerText="$t('text.tanksFilledReport.branchName')"
                ></e-column>
                <e-column
                  field="tankName"
                  width="200"
                  :headerText="$t('text.tanksFilledReport.tankName')"
                ></e-column>
                <e-column
                  field="filledVolume"
                  format="N2"
                  width="260"
                  :headerText="$t('text.tanksFilledReport.eVolumeDischarged')"
                ></e-column>
                <e-column
                  field="manualFilledVolume"
                  format="N2"
                  width="260"
                  :headerText="$t('text.tanksFilledReport.mVolumeDischarged')"
                ></e-column>
                <e-column
                  field="variance"
                  width="180"
                  format="N2"
                  :headerText="$t('text.tanksFilledReport.variance')"
                ></e-column>
                <e-column
                  field="startVolume"
                  format="N2"
                  width="210"
                  :headerText="$t('text.tanksFilledReport.eStartVolume')"
                ></e-column>
                <e-column
                  field="endVolume"
                  format="N2"
                  width="200"
                  :headerText="$t('text.tanksFilledReport.eVolumeEnd')"
                ></e-column>
                <e-column
                  field="manualStartVolume"
                  format="N2"
                  width="230"
                  :headerText="$t('text.tanksFilledReport.mStartVolume')"
                ></e-column>
                <e-column
                  field="manualEndVolume"
                  format="N2"
                  width="230"
                  :headerText="$t('text.tanksFilledReport.mEndVolume')"
                ></e-column>
                <e-column
                  field="plateNumber"
                  width="230"
                  :headerText="$t('text.fuelConsumption.plateNumber')"
                ></e-column>
                <e-column
                  field="startTime"
                  width="150"
                  :headerText="$t('text.tanksFilledReport.startTime')"
                ></e-column>
                <e-column
                  field="endTime"
                  width="150"
                  :headerText="$t('text.tanksFilledReport.endTime')"
                ></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </section>
      <section class="mt-5" style="margin: 0 auto; width: 96%">
        <TableLoader :showLoader="showLoader" />
      </section>
      <section
        class="products_summary__wrapper margin_products_top pb-3 mt-3"
        v-show="TanksFilledCount < 1 && !showLoader"
      >
        <div
          class="empty_tank_wrapper"
          style="
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column wrap;
          "
        >
          <div class="text-center" style="margin-top: 100px">
            <h3 style="color: rgb(161, 146, 146); font-size: 25px">
              {{ $t("text.tanksFilledReport.noTanksFilledOn") }}
              {{ $d(new Date(startDate), "short", this.$root.$i18n.locale) }}
            </h3>
          </div>

          <div class="animated__tanks__div text-center mt-5">
            <div class="bowl">
              <div class="inner">
                <div class="fill" style="background: grey; height: 0px">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="300px"
                    height="0px"
                    viewBox="0 0 300 300"
                    enable-background="new 0 0 300 300"
                    xml:space="preserve"
                  >
                    <path
                      class="waveShape"
                      d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4
                                            c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9
                                            c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div class="text-cente pb-5" style="margin-top: 50px">
            <h3 style="color: #e8e8e8; font-size: 25px"></h3>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Dealer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Tankimage.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

export default {
  title: "Tanks Filled :: Epump Portal",
  name: "TanksFilled",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: this.startDate,
      pluginStartDate: this.$moment().format("D-M-YYYY"),
      tanks: [],
      backgroundUrl,
      showLoader: false,
      dealerId: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      TanksFilledCount: 0,
      startDate: this.$moment().format("MMMM D, YYYY"),
      today: this.$moment().format("MMMM D, YYYY"),
      monthAgo: this.$moment().subtract(30, "days").format("MMMM D, YYYY"),
      disabledDates: [],
      dealer: null,
    };
  },
  created() {
    this.$eventHub.$on("dealer", (dealer) => {
      this.dealer = dealer;
    });
    if (this.$route.query.dealerId) {
      this.getTanks();
    }
    this.dateRange = this.pluginStartDate;
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.getTanks();
    // this.getDates();
  },
  watch: {
    dealer(dealer) {
      if (dealer !== null) {
        this.getTanks();
      }
    },
    dateRange: function (newDate) {
      if (newDate) {
        this.startDate = this.$moment(newDate, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getTanks();
      }
    },
  },
  methods: {
    //
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getTanks() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/DealerTanksFilled/${
            this.$route.query.dealerId
              ? this.$route.query.dealerId
              : this.dealer.id
          }?date=${this.startDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.TanksFilledCount = response.data.length;
          this.showLoader = false;
          let index = 0;
          let filledList = [];
          response.data.sort((a, b) => {
            return a.branchName > b.branchName
              ? 1
              : a.branchName < b.branchName
              ? -1
              : 0;
          });
          response.data.sort((a, b) => {
            if (a.branchName === b.branchName) {
              return a.tankName > b.tankName
                ? 1
                : a.tankName < b.tankName
                ? -1
                : 0;
            }
          });
          response.data.forEach((element) => {
            let startVolume = element.startVolume;
            let endVolume = element.endVolume;
            let filledVolume = element.filledVolume;
            let manualStartVolume = element.manualStartVolume;
            let manualEndVolume = element.manualEndVolume;
            let manualFilledVolume = element.manualFilledVolume;
            index++;
            element.index = index;
            element.startVolume = startVolume;
            element.manualStartVolume =
              manualStartVolume === null ? "N/A" : manualStartVolume;
            element.endVolume = endVolume;
            element.manualEndVolume =
              manualEndVolume === null ? "N/A" : manualEndVolume;
            element.filledVolume = filledVolume;
            element.manualFilledVolume =
              manualFilledVolume === null ? "N/A" : manualFilledVolume;
            element.variance =
              manualFilledVolume === null
                ? "N/A"
                : filledVolume - manualFilledVolume;
            element.startTime = this.$moment(element.startTime).format(
              "h:mm A"
            );
            element.endTime = this.$moment(element.endTime).format("h:mm A");
            filledList.push(element);
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: filledList,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
  },
};
</script>
